import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';

export default function HeroSection() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full h-screen min-h-[600px] overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="/assets/anthony/hero-fitting.jpg"
          alt="Anthony Sánchez ajustando un vestido de gala en su atelier de Barcelona"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/35" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-20 md:pb-28 px-6 lg:px-[7%] pt-28 lg:pt-32">
        <div
          className={`transition-all duration-1000 ease-out ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h1 className="font-serif text-white leading-[1.05] max-w-4xl">
            <span className="block text-[clamp(2.5rem,6vw,5.5rem)] font-light tracking-[0.12em] uppercase">
              Anthony Sánchez
            </span>
            <span className="block text-[clamp(1.5rem,3.5vw,3rem)] font-light italic tracking-wide mt-2">
              Couture & Artesanía
            </span>
          </h1>

          <p className="mt-8 font-sans text-white/80 text-base md:text-lg max-w-xl leading-relaxed">
            Alta costura exclusiva y arreglos profesionales en el corazón de Barcelona.
            Cada prenda es una obra de arte única, hecha a medida con pasión y dedicación.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link
              to="/alta-costura"
              className="inline-flex items-center justify-center bg-white text-brand-black font-sans text-sm tracking-widest uppercase px-10 py-4 rounded-full transition-all duration-300 hover:bg-white/90 hover:scale-105 whitespace-nowrap"
            >
              Reservar Cita Privada
            </Link>
            <Link
              to="/pret-a-porter"
              className="inline-flex items-center justify-center border border-white/60 text-white font-sans text-sm tracking-widest uppercase px-10 py-4 rounded-full transition-all duration-300 hover:bg-white/10 hover:scale-105 whitespace-nowrap"
            >
              Solicitar Arreglo
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}